import { createContext, PropsWithChildren, useMemo, useState } from 'react';

export interface VideoConferenceContextValue {
  extendedWidgetState: {
    showParticipants: boolean;
    showBreakoutRooms: boolean;
  };
  toggleParticipants: () => void;
  toggleBreakoutRooms: () => void;
}
export const VideoConferenceContext = createContext<VideoConferenceContextValue | null>(null);

export const VideoConferenceProvider = (props: PropsWithChildren) => {
  const [extendedWidgetState, setExtendedWidgetState] = useState({ showParticipants: false, showBreakoutRooms: false });

  const toggleParticipants = () => {
    setExtendedWidgetState((prevState) => ({
      ...prevState,
      showParticipants: !prevState.showParticipants,
    }));
  };

  const toggleBreakoutRooms = () => {
    setExtendedWidgetState((prevState) => ({
      ...prevState,
      showBreakoutRooms: !prevState.showBreakoutRooms,
    }));
  };

  const value = useMemo(
    () => ({
      extendedWidgetState,
      toggleParticipants,
      toggleBreakoutRooms,
    }),
    [extendedWidgetState],
  );

  return <VideoConferenceContext.Provider value={value}>{props.children} </VideoConferenceContext.Provider>;
};
